// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1h4G0","notes":"Notes_notes__5UWos","note":"Notes_note__IcnPc","markdown":"Notes_markdown__3WUXf"};